const discoverCodis = document.querySelector("#discover-codis");
if (discoverCodis) {
  let discoverSliderPromise = new Promise(function (sliderResolve) {
    const discoverSlider = tns({
      container: discoverCodis.querySelector(".slider"),
      items: 1,
      // center: true,
      autoplay: false,
      controls: true,
      nav: false,
      //navContainer: discoverCodis.querySelector('.team-slider-nav'),
      loop: false,
      autoplayButtonOutput: false,
      controlsContainer: discoverCodis.querySelector(".slider-controls"),
      speed: 400,
      gutter: 24,
      fixedHeight: true,
      //fixedWidth: 283,
      responsive: {
        768: {
          // items: 2,
          gutter: 24,
          fixedWidth: 283,
        },
        1024: {
          // items: 3,
          fixedWidth: 283,
          gutter: 24,
        },
        1200: {
          // items: 4,
          fixedWidth: 283,
          gutter: 24,

        },
      },
    });
    sliderResolve(discoverSlider.getInfo().container);

    discoverSliderPromise.then(function (sliderContainer) {
      // .. code after the slider has been built up
      console.log("discover codis slider is ready!");
      const slider = discoverCodis.querySelector(".slider");
      slider.classList.remove("space-x-6");
    });
  });
}
